import Vue from 'vue';
import config from 'config';
import { defineNuxtPlugin } from '~/.nuxt/imports';

// `app`/`store` are now present on the nuxt2Context
export default defineNuxtPlugin(function (_ref) {
  var app = _ref.nuxt2Context.app,
    provide = _ref.provide;
  provide('whitelabel', Vue.observable(config));

  /**
   * Set page-title and description based on translated & whitelabeled text
   */
  app.head.title = app.i18n.t('page.title');
  app.head.meta.push({
    hid: 'description',
    name: 'description',
    content: app.i18n.t('page.description')
  });

  // Dynamically update favicon from whitelabel lite branding, falling back to the static file
  // The data should be injected by the time onNuxtReady is called
  if (process.client) {
    window.onNuxtReady(function () {
      var _app$$whitelabelLite;
      var faviconUrl = (_app$$whitelabelLite = app.$whitelabelLite) === null || _app$$whitelabelLite === void 0 ? void 0 : _app$$whitelabelLite.faviconUrl;
      if (faviconUrl) {
        var link = document.querySelector('link[rel="icon"]');
        if (link) {
          link.href = faviconUrl;
        }
      }
    });
  }
});